import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../api/axios";

export default function CategoryCarousel() {
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [getwishlist, setGetWishlist] = useState([]);
  const [quantities, setQuantities] = useState({}); // 👈 track quantities per product
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("https://cartbackend.wsdstech.com/api/categories");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get("https://cartbackend.wsdstech.com/api/products");
      const data = response.data;

      // initialize quantities to 1 for each product
      const initialQuantities = {};
      data.forEach((item) => {
        initialQuantities[item.id] = 1;
      });
      setQuantities(initialQuantities);

      setProduct(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // 👇 quantity handlers
  const handleIncrease = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: prev[id] + 1,
    }));
  };

  const handleDecrease = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(1, prev[id] - 1), // min = 1
    }));
  };

  const handleQuantityChange = (id, value) => {
    const num = parseInt(value, 10);
    if (!isNaN(num) && num > 0) {
      setQuantities((prev) => ({
        ...prev,
        [id]: num,
      }));
    }
  };

const handleAddToCart = (product, qty = 1) => {
  if (!token) {
    // Guest user → store in localStorage
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingIndex = cart.findIndex((item) => item.product_id === product.id);

    if (existingIndex >= 0) {
      cart[existingIndex].quantity += qty;
    } else {
      cart.push({
        product_id: product.id,
        name: product.name,
        price: product.price,
        quantity: qty,
        image: product.image_url,
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    alert("✅ Added to cart (Guest mode)!");
    window.location.reload();
    return;
  }

  // Logged-in user → backend API
  axios
    .post(
      "https://cartbackend.wsdstech.com/api/cart",
      { product_id: product.id, quantity: qty, price: product.price },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then(() => {
      alert("✅ Added to cart (Logged-in)!");
      window.location.reload();
    })
    .catch((err) => {
      alert("❌ Error: " + (err.response?.data?.message || "Something went wrong"));
    });
};



  useEffect(() => {
    if (token) {
      axios
        .get("https://cartbackend.wsdstech.com/api/wishlist", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const ids = res.data.map((item) => item.product_id);
          setGetWishlist(ids);
        })
        .catch((err) => console.error("Wishlist fetch error:", err));
    }
  }, [token]);

const handleToggleWishlist = async (productId) => {
  if (!token) {
    // Guest User: Store wishlist in localStorage
    let guestWishlist = JSON.parse(localStorage.getItem("guestWishlist")) || [];

    if (guestWishlist.includes(productId)) {
      // Remove from guest wishlist
      guestWishlist = guestWishlist.filter((id) => id !== productId);
    } else {
      // Add to guest wishlist
      guestWishlist.push(productId);
    }

    // Save back to localStorage
    localStorage.setItem("guestWishlist", JSON.stringify(guestWishlist));

    // Update state (so UI updates instantly)
    setGetWishlist(guestWishlist);
    return;
  }

  // Logged-in user flow
  const isInWishlist = getwishlist.includes(productId);
  try {
    if (isInWishlist) {
      await axios.delete(`/wishlist/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setGetWishlist(getwishlist.filter((id) => id !== productId));
    } else {
      await axios.post(
        "/wishlist",
        { product_id: productId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setGetWishlist([...getwishlist, productId]);
    }
  } catch (error) {
    console.error("Error updating wishlist:", error);
  }
};


  return (
    <section className="py-5 overflow-hidden">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="section-header d-flex flex-wrap justify-content-between ">
              <h2 className="section-title">Hottest brands on offer</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="row px-5">
              {product.map((item) => (
                <div className="col-md-3 product-item" key={item.id}>
                  <Link
                    to="#"
                    className="btn-wishlist"
                    onClick={(e) => {
                      e.preventDefault();
                      handleToggleWishlist(item.id);
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    {getwishlist.includes(item.id) ? (
                      <i className="fa fa-solid fa-heart" style={{ color: "black" }}></i>
                    ) : (
                      <i className="fa fa-regular fa-heart"></i>
                    )}
                  </Link>
                  <figure>
                    <Link to={`/product/${item.id}`} title={item.name}>
                      <img
                        src={item.image_url}
                        className="tab-image"
                        alt={item.name}
                        style={{ objectFit: "cover", height: "200px", width: "100%" }}
                      />
                    </Link>
                  </figure>
                  <h3>{item.name}</h3>
                  <span className="qty">{item.quantity} Unit</span>
                  <span className="rating">
                    <i
                      className="fa fa-solid fa-star fa-1xs ml-1"
                      style={{ color: "#FFC107" }}
                    ></i>{" "}
                    4.5
                  </span>
                  <span className="price">₹{item.price}</span>

                  <div className="d-flex align-items-center justify-content-between">
                    <div className="input-group product-qty">
                      <span className="input-group-btn">
                        <button
                          type="button"
                          className="quantity-left-minus btn btn-danger btn-number"
                          onClick={() => handleDecrease(item.id)}
                        >
                          <i className="fa fa-solid fa-minus fa-2xs"></i>
                        </button>
                      </span>
                      <input
                        type="text"
                        name="quantity"
                        className="form-control input-number text-center"
                        value={quantities[item.id] || 1}
                        onChange={(e) => handleQuantityChange(item.id, e.target.value)}
                      />
                      <span className="input-group-btn">
                        <button
                          type="button"
                          className="quantity-right-plus btn btn-success btn-number"
                          onClick={() => handleIncrease(item.id)}
                        >
                          <i className="fa fa-solid fa-plus fa-2xs"></i>
                        </button>
                      </span>
                    </div>
                   <button
  style={{ border: "none" }}
  onClick={() => handleAddToCart(item, quantities[item.id] || 1)}
  className="nav-link"
>
  Add to Cart <iconify-icon icon="uil:shopping-cart"></iconify-icon>
</button>

                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
